/* ============================================================
   IMENHOF BLOOM — a11y-fixes.js
   Synchroon geladen vanuit de aankondigingssectie, dus dit draait
   vóór alle defer-scripts (theme.js).
   WCAG 2.2 AA-correcties:
   1) Aankondigingsbalk (SC 2.2.2): neemt de rotatie over van
      theme.js (data-announce wordt hier verwijderd voordat
      theme.js draait). Pauzeknop, pauze op hover/focus,
      respecteert prefers-reduced-motion en verbergt inactieve
      items voor screenreaders.
   2) Productgalerij: aria-current op de actieve thumbnail.
   ============================================================ */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- 1. Aankondigingsbalk ---- */
  [].forEach.call(document.querySelectorAll('[data-announce]'), function (box) {
    box.removeAttribute('data-announce'); /* theme.js slaat deze balk nu over */
    var items = box.querySelectorAll('.announce__item');
    var btn = box.querySelector('[data-announce-pause]');
    if (items.length < 2) { if (btn) btn.hidden = true; return; }
    function setItemActive(el, active) {
      el.classList.toggle('is-active', active);
      if (active) {
        el.removeAttribute('aria-hidden');
        el.removeAttribute('inert');
      } else {
        el.setAttribute('aria-hidden', 'true');
        el.setAttribute('inert', '');
      }
    }
    [].forEach.call(items, function (el) {
      setItemActive(el, el.classList.contains('is-active'));
    });
    if (REDUCED) { if (btn) btn.hidden = true; return; }
    var i = 0, t = null;
    function step() {
      setItemActive(items[i], false);
      i = (i + 1) % items.length;
      setItemActive(items[i], true);
    }
    function start() { if (!t && !box.classList.contains('is-paused')) t = setInterval(step, 4500); }
    function stop() { if (t) { clearInterval(t); t = null; } }
    box.addEventListener('mouseenter', stop);
    box.addEventListener('mouseleave', start);
    box.addEventListener('focusin', stop);
    box.addEventListener('focusout', start);
    if (btn) btn.addEventListener('click', function () {
      var p = box.classList.toggle('is-paused');
      btn.setAttribute('aria-pressed', p ? 'true' : 'false');
      btn.setAttribute('aria-label', p ? 'Hervat wisselende meldingen' : 'Pauzeer wisselende meldingen');
      if (p) stop(); else start();
    });
    start();
  });

  /* ---- 2. Galerij: aria-current op actieve thumbnail ---- */
  function initGallery() {
    [].forEach.call(document.querySelectorAll('.gallery__thumb'), function (th) {
      function sync() {
        if (th.classList.contains('is-active')) th.setAttribute('aria-current', 'true');
        else th.removeAttribute('aria-current');
      }
      new MutationObserver(sync).observe(th, { attributes: true, attributeFilter: ['class'] });
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGallery);
  } else { initGallery(); }
})();
